var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg0TaskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.9062 3C100.027 3 106.501 5.62293 110.939 10.0607C115.377 14.4985 118 20.9727 118 29.0938V91.9062C118 100.027 115.377 106.501 110.939 110.939C106.501 115.377 100.027 118 91.9062 118H29.0938C20.9727 118 14.4985 115.377 10.0607 110.939C5.62293 106.501 3 100.027 3 91.9062V29.0938C3 20.9727 5.62293 14.4985 10.0607 10.0607C14.4985 5.62293 20.9727 3 29.0938 3H91.9062Z",
    fill: "url(#paint0_radial_23_6)",
    stroke: "#65FC86",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2988 65.9209C75.3075 67.3883 77.6977 68.5749 79.3279 69.4054C80.9582 70.2359 81.9097 70.7515 81.8842 70.8037L81.6873 71.2075C81.6618 71.2597 80.6697 70.8274 79.0116 70.054C77.3535 69.2806 74.9469 68.1277 71.9382 66.6602L48.6673 55.3102C45.6586 53.8428 43.2682 52.6561 41.638 51.8256C40.0078 50.9952 39.0563 50.4796 39.0818 50.4274L39.2788 50.0236C39.3042 49.9714 40.2963 50.4037 41.9543 51.1771C43.6124 51.9504 46.0192 53.1034 49.0279 54.5709L72.2988 65.9209Z",
    fill: "#65FC86",
    stroke: "#65FC86",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61C84 81.4346 73.7026 98 61 98C48.2974 98 38 81.4346 38 61C38 40.5654 48.2974 24 61 24C73.7026 24 84 40.5654 84 61Z",
    stroke: "#65B4FC",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_23_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7058 28.4502) rotate(90) scale(120)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010043"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330134"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg0TaskLogo);
export default __webpack_public_path__ + "static/media/0task-logo.23d40150bb4d70e029cd1afaf53d5b82.svg";
export { ForwardRef as ReactComponent };